<!-- Drag the title to move the dialog -->
<h2 mat-dialog-title class="loan-amendment-title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    <span class="loan-amendment-title__text">Loan Amendment - {{data.type}}</span>
    <button mat-icon-button type="button" class="loan-amendment-close" aria-label="Close" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<!-- Step 1: look up the loan by its number -->
<form *ngIf="step === 'loan'" [formGroup]="loanForm" (ngSubmit)="next()">
    <mat-dialog-content class="loan-amendment-step">
        <div [@stepSlide]="{ value: step, params: { offset: slideOffset } }">
            <formly-form
                [form]="loanForm"
                [fields]="loanFields"
                [model]="formlyModel"></formly-form>
            <!-- Always rendered at a fixed height so the dialog doesn't resize (and re-center) when the message shows -->
            <div class="loan-search-status">
                <small class="text-danger">{{loanSearchMessage}}</small>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="loanForm.invalid || loanSearching">
            {{loanSearching ? 'Searching...' : 'Next'}}
        </button>
    </mat-dialog-actions>
</form>

<!-- Step 2: review / edit the details populated from the loan -->
<form *ngIf="step === 'details'" [formGroup]="detailsForm" (ngSubmit)="nextToRecipients()">
    <mat-dialog-content class="loan-amendment-step">
        <div [@stepSlide]="{ value: step, params: { offset: slideOffset } }">
            <p class="loan-number-summary">Loan Number: <strong>{{formlyModel.NLSLoanNumber}}</strong></p>
            <formly-form
                [form]="detailsForm"
                [fields]="detailsFields"
                [model]="formlyModel"></formly-form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="back()">Back</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="detailsForm.invalid">Next</button>
    </mat-dialog-actions>
</form>

<!-- Step 3: envelope recipients, same editor as the Agreements tab -->
<ng-container *ngIf="step === 'recipients'">
    <mat-dialog-content class="loan-amendment-step">
        <div [@stepSlide]="{ value: step, params: { offset: slideOffset } }">
            <div *ngIf="recipientsLoading">Loading recipients…</div>
            <small *ngIf="recipientsMessage" class="text-danger">{{recipientsMessage}}</small>
            <app-agreements-recipients
                *ngIf="recipientsData"
                [appData]="recipientsData"
                [application]="data.application"
                [currentUser]="data.currentUser"></app-agreements-recipients>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="back()">Back</button>
        <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="!recipientsData">Submit</button>
    </mat-dialog-actions>
</ng-container>
